<pc-image-banner 
    [imgUrl]="this.bannerImgUrl || ''"
>
</pc-image-banner>

<div class="site-gutter white-gutter border-bottom">
    <div class="main-copy-section">
        <div class="wrapper">
            <div class="copy-container">
                <div class="header-container">
                    <h1>Quality Metal Framing, Drywall Installation, and Acoustical Ceiling</h1>
                </div>
                <p>
                    For 30 years, PC Haines has served general contractors on projects throughout Central, Southcentral, & Southeast Pennsylvania, as a leading wall and ceiling contractor. PC Haines is a company built on the knowledge of three generations. Handed down from fathers to sons, our commitment to our quality and our clients remains strong and steady. 
                </p>
                <p>
                    We've worked on a wide scope of projects, including educational K-12, colleges & universities, municipal buildings, and military projects and are thoroughly familiar with all necessary paperwork involved with these tasks. It's our mission to provide superior workmanship at a competitive price, always professional and on time. 
                </p>
            </div>


            <div class="circles project-circles">
                <pc-project-circles></pc-project-circles>
            </div>

        </div>
    </div>
</div>

<!-- Cert Cards -->
<div class="secondary-content-section off-white-section">
    <div class="site-gutter white-gutter">
            <div class="secondary-copy-container">
                <h2>Industry Certifications & Standards</h2>
                <p>The safety and well-being of our employees, clients, and partners are our top priorities.</p>
            </div>
            <div class="card-container">
                <div class="card-row">
                    <div class="card">
                        <img src="https://tsgblob.blob.core.windows.net/pc-haines/assets/images/about/leed.webp" alt="LEED Certified Brand Logo" />
                        <div class="header-container">
                            <h4>LEED Certified</h4>
                        </div>
                        <p>We are LEED compliant when a project specifies environmental and energy efficiency standards set by the Leadership in Energy and Environmental Design (LEED) program. LEED certification is a globally recognized symbol of sustainability.</p>
                    </div>
                    <div class="card">
                        <img src="https://tsgblob.blob.core.windows.net/pc-haines/assets/images/about/osha.webp" alt="OSHA Brand Logo" />
                        <div class="header-container">
                            <h4>Osha Compliant</h4>
                        </div>
                        <p>PC Haines follows the Occupational Safety and Health Administration's (OSHA) rules and regulations to create a safe workplace. We are OSHA 10 & 30 Certified.</p>
                    </div>
                </div>

                <div class="card-row">
                    <div class="card">
                        <img src="https://tsgblob.blob.core.windows.net/pc-haines/assets/images/about/cpr.webp" alt="CPR Certified Logo" class="small-img" />
                        <div class="header-container">
                            <h4>CPR & First Aid Certified</h4>
                        </div>
                        <p>We are trained to administer life-saving CPR and First Aid to stabilize individuals until professional help arrives. Our commitment to workplace safety and regulatory compliance ensures a prepared environment for employees, clients, and visitors.</p>
                    </div>
                    <div class="card">
                        <img src="https://tsgblob.blob.core.windows.net/pc-haines/assets/images/about/hilti.webp" alt="Hilti Brand Logo" />
                        <div class="header-container">
                            <h4>Hilti Certified</h4>
                        </div>
                        <p>PC Haines is experienced in safely operating Hilti's powder-actuated tools and installing fire-stopping systems to maintain fire-resistance ratings. Our certification covers safety protocols, code compliance (e.g., ASTM, UL), and system integrity for structural safety. </p>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card">
                        <img src="https://tsgblob.blob.core.windows.net/pc-haines/assets/images/about/jlg.webp" alt="JLG Certified Logo"  />
                        <div class="header-container">
                            <h4>JLG Certified</h4>
                        </div>
                        <p>We are certified in safely operating JLG aerial lifts (boom lifts, scissor lifts) and telehandlers, covering pre-operation inspections, load management, maneuvering, and OSHA/ANSI compliance. Our training emphasizes hazard prevention, emergency protocols, and equipment maintenance to ensure workplace safety.</p>
                    </div>
                    <div class="card">
                        <img src="https://tsgblob.blob.core.windows.net/pc-haines/assets/images/about/pgcb.webp" alt="PGCB Logo" class="small-img" />
                        <div class="header-container">
                            <h4>PA Gaming Control Certified</h4>
                        </div>
                        <p>PC Haines is authorized to work on projects regulated by the Pennsylvania Gaming Control Board (PGCB). We ensure compliance with strict state gaming laws, security protocols, and ethical standards. </p>
                    </div>
                </div>
            </div>
    </div>
</div>

<!-- Bid Belt -->
<pc-seat-belt
    [copy]="'Ready to experience the PC Haines difference? Submit a bid request today.'"
    [buttonText]="'Submit a Request'"
    [buttonUrl]="'/contact-us'"
    [urlFragment]="'bid-request'"
></pc-seat-belt>

<!-- Photo Gallery -->
<div class="site-gutter white-gutter">
    <div class="full-page-gallery">
        <div class="wrapper">
            <div class="secondary-copy-container">
                <h2>Our Team</h2>
                <p>See the people behind the area's top wall and ceiling contractor services.</p>
            </div>
        </div>
        <div class="photo-gallery">
            @for (image of imageList; track $index) {
                <img src="{{image.url}}" alt="{{image.altText}}" [style]="'grid-row-end: span ' + image.gridRowEnd" (click)="openModal(image)">
        
                @if (selectedImage) {
                    <pc-image-modal [imageUrl]="selectedImage.url" (close)="closeModal()"></pc-image-modal>
                }
            }
        </div>
    </div>
</div>

<div class="site-gutter white-gutter">
    <div class="in-memory-of">
        <div class="in-memory-of-header">
            <h2>Roland “IKE” Eichelberger</h2>
            <p class="generation">(1st Generation)</p>
            <p class="year">1939—2012</p>
        </div>

        <div class="copy-content">
            <div class="copy first-block">
                <p>
                    Born in York, PA, the son of a textile designer, Ike followed in his dad's footsteps and became a textile designer. He was very good at it, but in the 70's, like a lot of things' work dried up. Desperate to feed his family Ike answered an ad in the newspaper to become a drywall finisher because it said no experience necessary, will train, start immediately. Ike went on to be known as one of the best hand finishers in Lancaster, PA. He immigrated to Nova Scotia with his family in the 70's. There he was an independent contractor drywall hanging and finishing homes, before expanding into commercial work.
                </p>
            </div>
            <div class="copy">
                <p>
                    During this journey Ike brought his sons Paul and Michael into the business. This is where Paul learned the trades. Ike was such a good teacher after his sons moved back to PA to go out on their own, he became a licensed teacher at the Springhill Penitentiary in Nova Scotia, teaching inmates the building trade from start to finish so they may leave and have productive lives. After 10 years teaching, he and his wife Audrey moved back to PA where he and his daughter Tina AKA “Little Ike” started their own drywall company called appropriately Eichelberger Drywall where he worked for 19 years until he retired.
                </p>
            </div>
        </div>
    </div>
</div>


<!-- Rememberance -->
<div class="site-gutter white-gutter">
    <div class="in-memory-of">
        <pc-ornate-frame></pc-ornate-frame>
        <div class="in-memory-of-header">
            <h2>Paul C. Haines</h2>
            <p class="generation">(2nd Generation)</p>
            <p class="year">1958-2016</p>
            <p>A tribute to the founder of PC Haines, Inc. Wall & Ceiling Contractor </p>
            <img src="https://tsgblob.blob.core.windows.net/pc-haines/assets/images/about/paul.webp" alt="Paul C. Haines, sitting on a boat, holding a large fish he caught.0">
        </div>

        <div class="copy-content">
            <div class="copy first-block">
                <p>
                    As a young man, Paul learned the trade of drywall from his father, Roland “Ike” Eichelberger. He worked with Ike in the early years, primarily residential, in Nova Scotia, Canada. When Paul was 24, he decided to start his own company back home in Lancaster, Pennsylvania. He gradually hired a few guys to work with him, and as time went on, his scope of work grew ranging from residential houses, malls, shopping centers, nursing homes, educational facilities, municipal complexes, military bases, and correctional facilities. His projects took him in and around Lancaster County, as well as out of state to New Jersey and Maryland.
                </p>
                <p>
                    Times were not always good or easy, but his vision continued to grow, and so did his company. Paul continued to work and thrive and never stopped learning. His relentless ability to learn aided in his desire to improve his business. Some learning was from “the school of hard knocks” and some was self-taught by computer and software programs.
                </p>
                <p>
                    For someone who was once “afraid” of computers, Paul was able to master them. He even became a beta tester for one of the companies whose software PC Haines still uses to this day. In time, Paul was recognized by the software company for his outstanding contribution to the program.
                </p>
            </div>
            <div class="copy">
                <p>
                    Paul's brain power was unbelievable. He had a photographic memory, just like his father. Paul could be driving down the road, and someone would call to ask him a question about a specific job. He could tell them what specific detail to look at and on the exact page of the prints, the specification, material measurements, etc.—just like that. The phone could ring again about a different job, and he'd carry out the same details.
                </p>
                <p>
                    As time went on, Paul continued to develop his business with the scope of work he completed and the abundance of manpower he obtained. PC Haines, Inc. grew to include structural metal framing, metal trusses, exterior sheathing, vapor barriers, drywall metal framing, insulation, drywall hanging and finishing, acoustic tile ceilings, acoustic wall panels, wood wall panels, and ceilings. The majority of PC Haines projects consist of, but are not limited to, schools and township buildings. Paul loved the diversity and challenge in commercial work—it was something that intrigued him. 
                </p>
                <p>
                    Attempting to figure out a solution to what needed to happen and the manner to do so continued to thrill him. Paul was an extraordinarily smart entrepreneur with no formal business education—only self-motivation and determination to pass his passion onto his family, which is only one of the countless ways we will remember him. Paul is the true meaning of the phrase “self-made man”.
                </p>

            </div>
        </div>
        <pc-ornate-frame></pc-ornate-frame>
    </div>
</div>


<div class="site-gutter white-gutter">
    <div class="in-memory-of">
        <div class="in-memory-of-header">
            <h2>Ryan M. Haines</h2>
            <p class="generation">(3rd Generation)</p>
            <p class="year">1988-Present</p>
        </div>

        <div class="copy-content">
            <div class="copy first-block">
                <p>
                    Ryan M. Haines, born in 1988, was brought into the construction business as soon as Paul could bring him along. Paul took Ryan out to job sites on the weekends to show him his future. Ryan would clean up the job sites and carry construction debris to the dumpster, help move materials. The whole time Paul would be educating Ryan on all aspects of the construction trades. Grandpa Ike always said everyone should know a little bit about every trade, not just the one you specialize in, and Paul passed this on to him. 
                </p>
                <p>
                    After graduating from Hempfield High School in 2007, Ryan went on to get a bachelor's degree in construction management in 2012, at Pennsylvania College of Technology in Williamsport, PA, working summers learning all aspects of PC Haines Inc. After graduation Ryan started as an assistant estimator & project manager at PC Haines Inc, Paul's assistant. 
                </p>
            </div>
            <div class="copy">
                <p>
                    Tragically we lost Paul in 2016, and Ryan was put to the test. He now had to pull from all that knowledge his dad taught him along with his education to keep the company running.  
                </p>
                <p>
                    In only a few short years Ryan has exceeded his dad's expectations no doubt. PC Haines is stronger than ever and thriving. On May 27th, 2024, the 4th generation began when Ryan's son Maximus Paul Haines was born. What a proud Grandpa Paul and Great Grandpa Ike would be if they were here. 
                </p>
            </div>
        </div>
    </div>
</div>